module.exports = __webpack_public_path__ + "media/application/images/home-logo-big-6101a4f1167084b1ffd9279baa15cd5b.svg";